import RichText from "@/components/RichText";

const FALLBACK_BLOCKS = [
  { id: "fallback-1", props: { date_label: "Étape 1", title: "Premier contact", desc: "" } },
  { id: "fallback-2", props: { date_label: "Étape 2", title: "Réalisation", desc: "" } },
];

const DEFAULTS = { eyebrow: "", heading: "Notre parcours", subheading: "", anchor_id: "" };

export default function TimelineSection({ props = {}, blocks }) {
  const t = { ...DEFAULTS, ...props };
  const steps = (blocks === undefined ? FALLBACK_BLOCKS : blocks).filter((b) => b.enabled !== false && b.props?.title);
  if (!steps.length) return null;

  return (
    <section id={t.anchor_id || undefined} className="max-w-[900px] mx-auto px-6 md:px-10 pt-section-top md:pt-section-top-md scroll-mt-28">
      <div className="text-center">
        {t.eyebrow && (
          <RichText as="p" className="text-[13px] font-semibold tracking-wide text-gold uppercase mb-3" html={t.eyebrow} />
        )}
        <RichText
          as="h2"
          className="font-display font-semibold text-[30px] md:text-[34px] leading-tight tracking-[-0.02em] text-ink"
          html={t.heading}
        />
        {t.subheading && <RichText as="p" preserveParagraphs className="text-[16px] text-graphite mt-4" html={t.subheading} />}
      </div>

      {/* Le filet vertical est porté par la liste et non par chaque étape :
          il s'arrête ainsi naturellement à la dernière, sans dépasser. */}
      <ol className="mt-10 border-l border-stone pl-6 md:pl-8">
        {steps.map((block) => (
          <li key={block.id} data-block-key={block.id} className="relative pb-8 last:pb-0">
            <span className="absolute -left-[calc(1.5rem+5px)] md:-left-[calc(2rem+5px)] top-1.5 h-2.5 w-2.5 rounded-full bg-gold" />
            {block.props.date_label && (
              <p className="text-[12px] font-semibold uppercase tracking-wide text-gold">{block.props.date_label}</p>
            )}
            <RichText as="p" className="text-[16px] font-semibold text-ink mt-0.5" html={block.props.title} />
            {block.props.desc && <p className="text-[14px] leading-relaxed text-graphite mt-1.5">{block.props.desc}</p>}
          </li>
        ))}
      </ol>
    </section>
  );
}
